"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisitedPlacesSection = void 0;
/*
 * Copyright 2025, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const react_i18next_1 = require("react-i18next");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const faTrashAlt_1 = require("@fortawesome/free-solid-svg-icons/faTrashAlt");
const faPencilAlt_1 = require("@fortawesome/free-solid-svg-icons/faPencilAlt");
const faPlusCircle_1 = require("@fortawesome/free-solid-svg-icons/faPlusCircle");
const faClock_1 = require("@fortawesome/free-solid-svg-icons/faClock");
const faArrowRight_1 = require("@fortawesome/free-solid-svg-icons/faArrowRight");
const GroupWidgets_1 = require("evolution-frontend/lib/components/survey/GroupWidgets");
const Widget_1 = require("evolution-frontend/lib/components/survey/Widget");
const surveyHelper = __importStar(require("evolution-common/lib/utils/helpers"));
const odSurveyHelper = __importStar(require("evolution-common/lib/services/odSurvey/helpers"));
const MathUtils_1 = require("chaire-lib-common/lib/utils/MathUtils");
const customHelpers = __importStar(require("../../common/helper"));
const ConfirmModal_1 = __importDefault(require("chaire-lib-frontend/lib/components/modal/ConfirmModal"));
const LoadingPage_1 = __importDefault(require("chaire-lib-frontend/lib/components/pages/LoadingPage"));
const useSectionTemplate_1 = require("evolution-frontend/lib/components/hooks/useSectionTemplate");
const SurveyContext_1 = require("evolution-frontend/lib/contexts/SurveyContext");
const frontendHelper_1 = require("evolution-frontend/lib/services/display/frontendHelper");
const helper_1 = require("../../common/helper");
const helpers_1 = require("evolution-common/lib/utils/helpers");
const activityIconMapping_1 = require("evolution-common/lib/services/questionnaire/sections/visitedPlaces/activityIconMapping");
const percentLengthOfOneSecond = 100.0 / (28 * 3600);
const VisitedPlacesSection = (props) => {
    var _a;
    const { preloaded } = (0, useSectionTemplate_1.useSectionTemplate)(props);
    const [confirmDeleteVisitedPlace, setConfirmDeleteVisitedPlace] = react_1.default.useState(null);
    const navigate = (0, react_router_1.useNavigate)();
    const location = (0, react_router_1.useLocation)();
    const surveyContext = react_1.default.useContext(SurveyContext_1.SurveyContext);
    const { t, i18n } = (0, react_i18next_1.useTranslation)('survey');
    const addVisitedPlace = (sequence, path, e) => {
        if (e) {
            e.preventDefault();
        }
        // Add a new place at sequence
        props.startAddGroupedObjects(1, sequence, path, [], (interview) => {
            const person = odSurveyHelper.getPerson({ interview });
            const currentJourney = odSurveyHelper.getActiveJourney({ interview });
            const visitedPlaces = odSurveyHelper.getVisitedPlacesArray({ journey: currentJourney });
            // Get the inserted visited place, if sequence is -1, get the last one
            const insertedVisitedPlace = sequence === -1
                ? visitedPlaces[visitedPlaces.length - 1]
                : visitedPlaces.find((visitedPlace) => visitedPlace._sequence === sequence);
            const insertedVisitedPlacePath = `household.persons.${person._uuid}.journeys.${currentJourney._uuid}.visitedPlaces.${insertedVisitedPlace._uuid}`;
            const previousVisitedPlace = odSurveyHelper.getPreviousVisitedPlace({
                journey: currentJourney,
                visitedPlaceId: insertedVisitedPlace._uuid
            });
            const nextVisitedPlace = odSurveyHelper.getNextVisitedPlace({
                journey: currentJourney,
                visitedPlaceId: insertedVisitedPlace._uuid
            });
            const updateValuesByPath = {};
            //we must change from previous place `nextPlaceCategory`
            // `nextPlaceCategory` can be null excepte for last visitedPlace
            // we can't assigne last visitedPlace `nextPlaceCategory` here since we don't know yet what type of place user want to add (home, work, other).
            if (previousVisitedPlace && sequence > 1) {
                const previousVisitedPlacePath = `household.persons.${person._uuid}.journeys.${currentJourney._uuid}.visitedPlaces.${previousVisitedPlace._uuid}`;
                updateValuesByPath[`response.${previousVisitedPlacePath}.nextPlaceCategory`] = null;
                // FIXME, copy-pasted, but _previousDepartureTime is a boolean?
                updateValuesByPath[`response.${insertedVisitedPlacePath}._previousDepartureTime`] =
                    sequence === previousVisitedPlace.departureTime;
            }
            //we must change _previousDepartureTime for nextVisitedPlace and set it to null
            if (nextVisitedPlace && sequence > 1) {
                const nextVisitedPlacePath = `household.persons.${person._uuid}.journeys.${currentJourney._uuid}.visitedPlaces.${nextVisitedPlace._uuid}`;
                updateValuesByPath[`response.${nextVisitedPlacePath}._previousDepartureTime`] = null;
            }
            //we set added visited place as active place
            const firstIncompleteVisitedPlace = (0, helper_1.selectNextIncompleteVisitedPlace)({ visitedPlaces, person, interview });
            updateValuesByPath['response._activeVisitedPlaceId'] = insertedVisitedPlace
                ? insertedVisitedPlace._uuid
                : firstIncompleteVisitedPlace !== null
                    ? firstIncompleteVisitedPlace._uuid
                    : null;
            props.startUpdateInterview({ sectionShortname: 'visitedPlaces', valuesByPath: updateValuesByPath });
        });
    };
    const selectVisitedPlace = (visitedPlaceUuid, e) => {
        if (e) {
            e.preventDefault();
        }
        props.startUpdateInterview({
            sectionShortname: 'visitedPlaces',
            valuesByPath: { ['response._activeVisitedPlaceId']: visitedPlaceUuid }
        });
    };
    const deleteVisitedPlace = (person, visitedPlacePath, visitedPlace, visitedPlaces, e = undefined) => {
        if (e) {
            e.preventDefault();
        }
        customHelpers.deleteVisitedPlace(visitedPlacePath, props.interview, props.startRemoveGroupedObjects, props.startUpdateInterview);
    };
    if (!preloaded) {
        return react_1.default.createElement(LoadingPage_1.default, null);
    }
    // Prepare required data
    surveyHelper.devLog('%c rendering section ' + props.shortname, 'background: rgba(0,0,255,0.1);');
    const widgetsComponentsByShortname = {};
    const personVisitedPlacesConfig = surveyContext.widgets['personVisitedPlaces'];
    const person = odSurveyHelper.getPerson({ interview: props.interview });
    const currentJourney = odSurveyHelper.getActiveJourney({ interview: props.interview, person });
    const interviewablePersons = odSurveyHelper.getInterviewablePersonsArray({ interview: props.interview });
    const isAlone = interviewablePersons.length === 1;
    // setup schedules for all interviewable persons:
    // FIXME Extract to a function component, the for loop has a lot of variables in common with the main block
    const widgetsSchedules = [];
    let activePersonSchedule = null;
    const selectedVisitedPlaceId = (_a = odSurveyHelper.getActiveVisitedPlace({
        interview: props.interview,
        journey: currentJourney
    })) === null || _a === void 0 ? void 0 : _a._uuid;
    for (let i = 0; i < interviewablePersons.length; i++) {
        const personForSchedule = interviewablePersons[i];
        const isPersonActive = personForSchedule._uuid === person._uuid;
        let atLeastOneCompletedVisitedPlace = false;
        const journeysForSchedule = odSurveyHelper.getJourneysArray({ person: personForSchedule });
        const journeyForSchedule = journeysForSchedule[0];
        const visitedPlacesForSchedule = journeyForSchedule !== undefined
            ? odSurveyHelper.getVisitedPlacesArray({ journey: journeyForSchedule })
            : [];
        const personVisitedPlacesSchedules = [];
        for (let i = 0, count = visitedPlacesForSchedule.length; i < count; i++) {
            const visitedPlace = visitedPlacesForSchedule[i];
            const visitedPlaceDescription = (0, frontendHelper_1.getVisitedPlaceDescription)(visitedPlace, true, false);
            let departureTime = i === count - 1 ? 28 * 3600 : null;
            let arrivalTime = i === 0 ? 0 : null;
            if (visitedPlace.departureTime) {
                departureTime = visitedPlace.departureTime;
            }
            if (visitedPlace.arrivalTime) {
                arrivalTime = visitedPlace.arrivalTime;
            }
            if (visitedPlace.activityCategory && !(0, LodashExtensions_1._isBlank)(departureTime) && !(0, LodashExtensions_1._isBlank)(arrivalTime)) {
                atLeastOneCompletedVisitedPlace = true;
            }
            else {
                continue;
            }
            const startAtPercent = (0, MathUtils_1.roundToDecimals)(arrivalTime * percentLengthOfOneSecond, 4);
            const width = (0, MathUtils_1.roundToDecimals)(departureTime * percentLengthOfOneSecond - startAtPercent, 4);
            const visitedPlaceSchedule = (react_1.default.createElement("div", { className: `survey-visited-places-schedule-visited-place${isPersonActive && !selectedVisitedPlaceId ? ' hand-cursor-on-hover' : ''}`, key: visitedPlace._uuid, style: { left: startAtPercent.toString() + '%', width: width.toString() + '%' }, title: visitedPlaceDescription, onClick: props.interview.allWidgetsValid && isPersonActive && !selectedVisitedPlaceId
                    ? (e) => selectVisitedPlace(visitedPlace._uuid, e)
                    : null },
                react_1.default.createElement("div", { className: "survey-visited-places-schedule-visited-place-icon" },
                    react_1.default.createElement("img", { src: (0, activityIconMapping_1.getActivityIcon)(visitedPlace.activity), style: { height: '1.8em', padding: '0.1em' }, alt: visitedPlace.activity
                            ? t(`survey:visitedPlace:activities:${visitedPlace.activity}`)
                            : '' }),
                    react_1.default.createElement("p", null,
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faClock_1.faClock, style: { marginRight: '0.3rem', marginLeft: '0.6rem' } }),
                        visitedPlace.arrivalTime &&
                            (0, frontendHelper_1.secondsSinceMidnightToTimeStrWithSuffix)(visitedPlace.arrivalTime, t('main:theNextDay')),
                        visitedPlace.departureTime && (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faArrowRight_1.faArrowRight, style: { marginRight: '0.3rem', marginLeft: '0.3rem' } })),
                        visitedPlace.departureTime &&
                            (0, frontendHelper_1.secondsSinceMidnightToTimeStrWithSuffix)(visitedPlace.departureTime, t('main:theNextDay'))))));
            personVisitedPlacesSchedules.push(visitedPlaceSchedule);
        }
        if (atLeastOneCompletedVisitedPlace) {
            const personSchedule = (react_1.default.createElement("div", { className: "survey-visited-places-schedule-person-container", key: personForSchedule._uuid },
                react_1.default.createElement("p", { className: personForSchedule._uuid === person._uuid ? ' _orange' : '' },
                    react_1.default.createElement("span", { dangerouslySetInnerHTML: {
                            __html: t('survey:person:dayScheduleFor', {
                                nickname: personForSchedule.nickname,
                                count: interviewablePersons.length
                            })
                        } })),
                react_1.default.createElement("div", { className: "survey-visited-places-schedule-person" }, personVisitedPlacesSchedules)));
            if (isPersonActive) {
                activePersonSchedule = personSchedule;
            }
            else {
                widgetsSchedules.push(personSchedule);
            }
        }
    }
    if (activePersonSchedule) {
        widgetsSchedules.push(activePersonSchedule);
    }
    // setup widgets:
    for (let i = 0, count = props.sectionConfig.widgets.length; i < count; i++) {
        const widgetShortname = props.sectionConfig.widgets[i];
        widgetsComponentsByShortname[widgetShortname] = (react_1.default.createElement(Widget_1.Widget, { key: widgetShortname, currentWidgetShortname: widgetShortname, nextWidgetShortname: props.sectionConfig.widgets[i + 1], sectionName: props.shortname, interview: props.interview, errors: props.errors, user: props.user, loadingState: props.loadingState, startUpdateInterview: props.startUpdateInterview, startAddGroupedObjects: props.startAddGroupedObjects, startRemoveGroupedObjects: props.startRemoveGroupedObjects, startNavigate: props.startNavigate }));
    }
    // setup visited places:
    const visitedPlaces = odSurveyHelper.getVisitedPlacesArray({ journey: currentJourney });
    const lastVisitedPlace = visitedPlaces.length > 0 ? visitedPlaces[visitedPlaces.length - 1] : null;
    const visitedPlacesList = [];
    for (let i = 0, count = visitedPlaces.length; i < count; i++) {
        const visitedPlace = visitedPlaces[i];
        const isPlaceSelected = selectedVisitedPlaceId && visitedPlace._uuid === selectedVisitedPlaceId;
        const activity = visitedPlace.activity;
        const actualVisitedPlace = visitedPlace.shortcut
            ? (0, helpers_1.getResponse)(props.interview, visitedPlace.shortcut, visitedPlace)
            : visitedPlace;
        const visitedPlacePath = `household.persons.${person._uuid}.journeys.${currentJourney._uuid}.visitedPlaces.${visitedPlace._uuid}`;
        const visitedPlaceItem = (react_1.default.createElement("li", { className: `no-bullet survey-visited-place-item${isPlaceSelected ? ' survey-visited-place-item-selected' : ''}`, key: `survey-visited-place-item__${i}` },
            react_1.default.createElement("span", { className: "survey-visited-place-item-element survey-visited-place-item-sequence-and-icon" },
                visitedPlace._sequence,
                ".",
                ' ',
                activity && (react_1.default.createElement("div", { className: "survey-visited-place-item-icon-container" },
                    react_1.default.createElement("img", { src: (0, activityIconMapping_1.getActivityIcon)(activity), style: { height: '3rem' }, alt: activity ? t(`survey:visitedPlace:activities:${activity}`) : '' })))),
            react_1.default.createElement("span", { className: "survey-visited-place-item-element survey-visited-place-item-description text-box-ellipsis" },
                react_1.default.createElement("span", { className: isPlaceSelected ? '_strong' : '' },
                    activity && t(`survey:visitedPlace:activities:${activity}`),
                    actualVisitedPlace.name && react_1.default.createElement("em", null,
                        "\u00A0\u2022 ",
                        actualVisitedPlace.name))),
            react_1.default.createElement("span", { className: "survey-visited-place-item-element survey-visited-place-item-buttons" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faClock_1.faClock, style: { marginRight: '0.3rem', marginLeft: '0.6rem' } }),
                visitedPlace.arrivalTime &&
                    (0, frontendHelper_1.secondsSinceMidnightToTimeStrWithSuffix)(visitedPlace.arrivalTime, t('main:theNextDay')),
                visitedPlace.departureTime && (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faArrowRight_1.faArrowRight, style: { marginRight: '0.3rem', marginLeft: '0.3rem' } })),
                visitedPlace.departureTime &&
                    (0, frontendHelper_1.secondsSinceMidnightToTimeStrWithSuffix)(visitedPlace.departureTime, t('main:theNextDay')),
                !selectedVisitedPlaceId /*state.editActivated*/ && props.loadingState === 0 && (react_1.default.createElement("button", { type: "button", className: 'survey-section__button button blue small', onClick: (e) => selectVisitedPlace(visitedPlace._uuid, e), style: { marginLeft: '0.5rem' }, title: t('survey:visitedPlace:editVisitedPlace') },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faPencilAlt_1.faPencilAlt, className: "" }))),
                !selectedVisitedPlaceId /*state.editActivated*/ &&
                    props.loadingState === 0 &&
                    visitedPlaces.length > 1 && (react_1.default.createElement("button", { type: "button", className: 'survey-section__button button red small', onClick: (e) => setConfirmDeleteVisitedPlace(visitedPlacePath), title: t('survey:visitedPlace:deleteVisitedPlace') },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faTrashAlt_1.faTrashAlt, className: "" }))),
                confirmDeleteVisitedPlace === visitedPlacePath && (react_1.default.createElement("div", null,
                    react_1.default.createElement(ConfirmModal_1.default, { isOpen: true, closeModal: () => setConfirmDeleteVisitedPlace(null), text: surveyHelper.translateString(personVisitedPlacesConfig.deleteConfirmPopup.content, i18n, props.interview, props.shortname), title: personVisitedPlacesConfig.deleteConfirmPopup.title
                            ? surveyHelper.translateString(personVisitedPlacesConfig.deleteConfirmPopup.title, i18n, props.interview, props.shortname)
                            : null, cancelAction: null, confirmAction: (e) => deleteVisitedPlace(person, visitedPlacePath, visitedPlace, visitedPlaces, e), containsHtml: personVisitedPlacesConfig.deleteConfirmPopup.containsHtml }))))));
        visitedPlacesList.push(visitedPlaceItem);
        if (selectedVisitedPlaceId && isPlaceSelected) {
            const parentObjectIds = {};
            parentObjectIds['personVisitedPlaces'] = visitedPlace._uuid;
            const selectedVisitedPlaceComponent = (react_1.default.createElement("li", { className: "no-bullet", style: { marginTop: '-0.4rem' }, key: `survey-visited-place-item-selected__${i}` },
                react_1.default.createElement(GroupWidgets_1.GroupedObject, { widgetConfig: personVisitedPlacesConfig, shortname: "personVisitedPlaces", path: visitedPlacePath, loadingState: props.loadingState, objectId: visitedPlace._uuid, parentObjectIds: parentObjectIds, key: `survey-visited-place-item-selected-${visitedPlace._uuid}`, sequence: visitedPlace['_sequence'], section: 'visitedPlaces', interview: props.interview, user: props.user, errors: props.errors, startUpdateInterview: props.startUpdateInterview, startAddGroupedObjects: props.startAddGroupedObjects, startRemoveGroupedObjects: props.startRemoveGroupedObjects, startNavigate: props.startNavigate })));
            visitedPlacesList.push(selectedVisitedPlaceComponent);
        }
        if (!selectedVisitedPlaceId &&
            props.loadingState === 0 &&
            visitedPlaces.length > 1 &&
            ((lastVisitedPlace && lastVisitedPlace._uuid !== visitedPlace._uuid) ||
                (lastVisitedPlace._uuid === visitedPlace._uuid &&
                    visitedPlace.nextPlaceCategory === 'stayedThereUntilTheNextDay'))) {
            visitedPlacesList.push(react_1.default.createElement("li", { className: "no-bullet survey-visited-place-insert", key: `survey-visited-place-item-insert-after__${i}`, style: { marginTop: '-0.4em', marginLeft: '2rem', padding: 0 } },
                react_1.default.createElement("button", { type: "button", className: "button blue center small", onClick: (e) => addVisitedPlace(visitedPlace['_sequence'] + 1, `household.persons.${person._uuid}.journeys.${currentJourney._uuid}.visitedPlaces`, e), title: t('survey:visitedPlace:insertVisitedPlace') },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faPlusCircle_1.faPlusCircle, className: "faIconLeft" }),
                    t('survey:visitedPlace:insertVisitedPlace'))));
        }
    }
    return (react_1.default.createElement("section", { className: `survey-section survey-section-shortname-${props.shortname}` },
        react_1.default.createElement("div", { className: "survey-section__content" },
            widgetsComponentsByShortname['activePersonTitle'],
            widgetsComponentsByShortname['buttonSwitchPerson'],
            react_1.default.createElement("div", { className: "survey-visited-places-schedules" }, widgetsSchedules),
            react_1.default.createElement("div", { className: "survey-visited-places-list-and-map-container" },
                react_1.default.createElement("ul", { className: `survey-visited-places-list ${selectedVisitedPlaceId || visitedPlaces.length <= 1 ? 'full-width' : ''}` },
                    widgetsComponentsByShortname['personVisitedPlacesTitle'],
                    visitedPlacesList,
                    !selectedVisitedPlaceId &&
                        ((lastVisitedPlace &&
                            lastVisitedPlace.nextPlaceCategory !== 'stayedThereUntilTheNextDay') ||
                            visitedPlaces.length === 1) &&
                        props.loadingState === 0 && (react_1.default.createElement("button", { type: "button", className: "button blue center large", onClick: (e) => addVisitedPlace(-1, `household.persons.${person._uuid}.journeys.${currentJourney._uuid}.visitedPlaces`, e), title: t('survey:visitedPlace:addVisitedPlace') },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faPlusCircle_1.faPlusCircle, className: "faIconLeft" }),
                        t('survey:visitedPlace:addVisitedPlace')))),
                !selectedVisitedPlaceId && visitedPlaces.length > 1 && (react_1.default.createElement("div", { className: 'survey-visited-places-map' }, widgetsComponentsByShortname['personVisitedPlacesMap']))),
            visitedPlaces.length > 1 &&
                !selectedVisitedPlaceId &&
                widgetsComponentsByShortname['buttonVisitedPlacesConfirmNextSection'])));
};
exports.VisitedPlacesSection = VisitedPlacesSection;
exports.default = exports.VisitedPlacesSection;
